import {jExcelProvinces} from 'src/app/metadata/province';
import {TABLECOLUMNS} from 'src/app/shared/components/excel-table/excel-table';
import {isFullTime, isPartTime, isSSOAgeValid, validateID, validateSsoIdCard} from 'src/app/shared/utils/utils-employee';
import {Setting} from './employee-deduction';
import {ListFemale, ListMale, TitleNames} from './titleName';
import { formatDecimalPrice } from 'src/app/shared/utils/utils';
import { get } from 'lodash';
import { getCellKey } from 'src/app/shared/utils/utils-table';

export interface ProfileSetting extends Setting {
  warning?: string[];
  fields?: string[];
  objValue?: any;
}
export interface EmployeeS {
  employee_id?: string;
  ID?: string;
  first_name: string;
  last_name: string;
  nickname: string;
  enable_delete?: boolean;
  title: string;
  color_bg_code?: string;
}

export interface Employee extends EmployeeS {
  title_en: string;
  first_name_en: string;
  last_name_en: string;
  birth_date: string;
  id_card: string;
  sso_id_card: string;
  sex: string;
  nationality: string;
  marital_status: string;
  disability_status: string;
  highest_education: string;
  employment_type: string;
  employment_id: string;
  position: string;
  department: string;
  team: string;
  bank_id: string;
  bank_account: string;
  bank_account_name: string;
  company_email: string;
  personal_email: string;
  phone1: string;
  phone2: string;
  emergency_contact_no: string;
  emergency_contact_person: string;
  emergency_contact_relationship: string;
  student_loan: string;
  student_loan_end_date: string;
  student_loan_organization?: string;
  provident_fund: string;
  provident_fund_organization?: string;
  weight?: string;
  height?: string;
  salary: string;
  salary_period: string;
  picture?: string;
  start_date: string;
  sso_start_date: string;
  id_card_address: EmployeeAddress;
  contact_address?: EmployeeAddress;
  dates: any[];
  end_date?: string;
  app_connected: boolean;
}

export interface EmployeeAddress {
  street_no: string;
  moo_no: string;
  building: string;
  room_no: string;
  floor_no: string;
  village_name: string;
  soi: string;
  alley: string;
  lane: string;
  road: string;
  sub_district: string;
  district: string;
  province: string;
  postal_code: string;
}

export enum EmployeeStatus {
  SELF_ONBOARDING = 'SELF_ONBOARDING',
  COMPLETED = 'COMPLETED'
}

export interface Employee {
  employee_id?: string;
  title: string;
  first_name: string;
  last_name: string;
  nickname: string;
  title_en: string;
  first_name_en: string;
  last_name_en: string;
  birth_date: string;
  id_card: string;
  sso_id_card: string;
  sex: string;
  nationality: string;
  marital_status: string;
  disability_status: string;
  highest_education: string;
  employment_type: string;
  employment_id: string;
  position: string;
  department: string;
  team: string;
  bank_id: string;
  bank_account: string;
  bank_account_name: string;
  company_email: string;
  personal_email: string;
  phone1: string;
  phone2: string;
  emergency_contact_no: string;
  emergency_contact_person: string;
  emergency_contact_relationship: string;
  student_loan: string;
  student_loan_end_date: string;
  student_loan_organization?: string;
  provident_fund: string;
  provident_fund_info?: string;
  weight?: string;
  height?: string;
  salary: string;
  salary_period: string;
  picture?: string;
  start_date: string;
  sso_start_date: string;
  id_card_address: EmployeeAddress;
  contact_address?: EmployeeAddress;
  status?: EmployeeStatus;
  data?: any;
}

// export const TitleNames = [
//   {id: 1, name: 'นาย'},
//   {id: 2, name: 'นาง'},
//   {id: 3, name: 'นางสาว'}
// ];

export const TitleENNames = [
  {id: 1, name: 'Mr.'},
  {id: 2, name: 'Mrs.'},
  {id: 3, name: 'Miss'},
  {id: 4, name: 'Dr.'}
];

export const TitleNameSynonyms = [
  {name: 'นางสาว', synonyms: ['นาวสาว', 'นส.', 'น ส.', 'น.ส.', 'น. ส.', 'น ส']}
];

export const Employments = [
  {id: 1, name: 'เจ้าของ'},
  {id: 2, name: 'พนักงานประจำ'},
  {id: 3, name: 'Part-time'},
];

export const Genders = [
  {id: 1, name: 'ชาย'},
  {id: 2, name: 'หญิง'}
];

export const Nationalities = [
  {id: 1, name: 'ไทย'}
];

export const Status = [
  {id: 1, name: 'โสด'},
  {id: 2, name: 'สมรส'}
];

export const Units = [
  {id: 1, name: 'เดือน'},
  {id: 2, name: 'วัน'}
];

export const Disabilities = [
  {id: 1, name: 'ปกติ'},
  {id: 2, name: 'พิการ'},
  {id: 3, name: 'ทุพพลภาพ'}
];

export const PvdTypes = [
  {id: 'percentage', name: '%'},
  {id: 'baht', name: 'บาท'}
];
export const PvdTypePercent = 'percentage';

export const Banks = [
  {id: 1, name: 'KBANK', logo: '/assets/images/bank-logo/ico-kbank.png'},
  {id: 2, name: 'SCB', logo: '/assets/images/bank-logo/ico-scb.png'},
  {id: 3, name: 'BBL', logo: '/assets/images/bank-logo/ico-bbl.png'},
  {id: 4, name: 'BAY', logo: '/assets/images/bank-logo/ico-bay.png'},
  {id: 5, name: 'KTB', logo: '/assets/images/bank-logo/ico-ktb.png'},
  {id: 6, name: 'TTB', logo: '/assets/images/bank-logo/ico-ttb.png'},
  {id: 8, name: 'UOB', logo: '/assets/images/bank-logo/ico-uob.png'},
  {id: 7, name: 'GSB', logo: '/assets/images/bank-logo/ico-gsb.png'}
];

export const PVDInfo = [
  {id: 1, name: 'AIA - เอไอเอ'},
  {id: 2, name: 'ABERDEEN - อเบอร์ดีน'},
  {id: 3, name: 'BBLAM - บัวหลวง'},
  {id: 4, name: 'BCAP - บางกอกแคปปิตอล'},
  {id: 5, name: 'KASSET - กสิกรไทย'},
  {id: 6, name: 'KSAM - กรุงศรี'},
  {id: 7, name: 'KTAM - กรุงไทย'},
  {id: 8, name: 'LHFUND - แลนด์ แอนด์ เฮ้าส์'},
  {id: 9, name: 'MFC - เอ็มเอฟซี'},
  {id: 10, name: 'ONE - วรรณ'},
  {id: 11, name: 'PRINCIPAL - พรินซิเพิล'},
  {id: 12, name: 'SCBAM - ไทยพาณิชย์'},
  {id: 13, name: 'TFUND - ธนาชาต'},
  {id: 14, name: 'TISCO - ทิสโก้'},
  {id: 15, name: 'TMBAM - ทหารไทย'},
  {id: 16, name: 'UOBAM - ยูโอบี'},
];

export enum SettingType {
  ALL = 1,
  ABOUT,
  EMPLOYMENT,
  CONTACT,
  CONTACT_IDCARDADDRESS,
  CONTACT_CONTACTADDRESS,
  OTHER,
  DEDUCTION,
  ABSENCE_HOLIDAY,
  ABSENCE_OTHER
}

export const getPvdType = (name: string): any => {
  let item = PvdTypes.find(o => o.name == name)
  return (item) ? item.id : null
}

const onTitleChange = (instance, cell, x, y, value) => {
  const sexIndex = instance.jexcel.options.columns.findIndex(col => col.name === 'sex');
  if (sexIndex > -1) {
    let sex = '';
    if (ListMale.includes(value)) {
      sex = 'ชาย';
    } else if (ListFemale.includes(value)) {
      sex = 'หญิง';
    }
    instance.jexcel.setValueFromCoords(sexIndex, y, sex);
  }
};

const onSsoDateChange = (instance, cell, x, y, value) => {
  const ssoIdIndex = instance.jexcel.options.columns.findIndex(col => col.name === 'sso_id');
  if (ssoIdIndex > -1) {
    // instance.jexcel.setValueFromCoords(ssoIdIndex, y, sex);
  }
};

const onBankIdChange = (instance, cell, x, y, value) => {
  const bankIdIdIndex = instance.jexcel.options.columns.findIndex(col => col.name === 'bank_id');
  if (bankIdIdIndex > -1) {
    // instance.jexcel.setValueFromCoords(ssoIdIndex, y, sex);
  }
};

const onIDChange = (instance, cell, x, y, value) => {
  const isValid = validateID(value);
  if (isValid || !value) {
    cell.style.borderTopColor = '#dee2e6';
    cell.style.borderLeftColor = '#dee2e6';
    cell.style.borderBottomColor = 'transparent';
    cell.style.borderRightColor = 'transparent';
  } else {
    cell.style.borderColor = '#f95d9e';
  }
};

export const onPvdTypeChange = (instance, cell, x, y, value) => {
  const index = instance.jexcel.options.columns.findIndex(col => col.name === 'provident_fund');
  if (index > -1) {
    instance.jexcel.setValueFromCoords(index, y, null);
  }
};

export const onPvdEmployerTypeChange = (instance, cell, x, y, value) => {
  const index = instance.jexcel.options.columns.findIndex(col => col.name === 'provident_fund_employer');
  if (index > -1) {
    instance.jexcel.setValueFromCoords(index, y, null);
  }
};

export const onEmploymentTypeChange = (instance, cell, x, y, value) => {
  instance = updateSSOCell(instance, y)
};

export const onBirthDateChange = (instance, cell, x, y, value) => {
  instance = updateSSOCell(instance, y)
};

export const onStartDateChange = (instance, cell, x, y, value) => {
  instance = updateSSOCell(instance, y)
};

const ssoCustomReadonly = (datasource): boolean => {
  return isSSODisable(get(datasource, 'employment_type'), get(datasource, 'birth_date'), get(datasource, 'start_date'))
};

function isSSODisable(employmentType: string, birthDate: string, startDate: string): boolean {
  return !isFullTime(employmentType) || !isSSOAgeValid(birthDate, startDate)
}

function updateSSOCell(instance: any, y: any): any {
  const employmentTypeIndex = instance.jexcel.options.columns.findIndex(col => col.name === 'employment_type');
  const birthDateIndex = instance.jexcel.options.columns.findIndex(col => col.name === 'birth_date');
  const startDateIndex = instance.jexcel.options.columns.findIndex(col => col.name === 'start_date');

  let employmentType = instance.jexcel.getValueFromCoords(employmentTypeIndex, y)
  let birthDate = instance.jexcel.getValueFromCoords(birthDateIndex, y)
  let startDate = instance.jexcel.getValueFromCoords(startDateIndex, y)
  let isDisable = isSSODisable(employmentType, birthDate, startDate)

  const ssoIdIndex = instance.jexcel.options.columns.findIndex(col => col.name === 'sso_id_card');
  const ssoDateIndex = instance.jexcel.options.columns.findIndex(col => col.name === 'sso_start_date');
  if (ssoIdIndex > -1) {
    if (isDisable) {
      instance.jexcel.setValueFromCoords(ssoIdIndex, y, null, true);
    }
    instance.jexcel.setReadOnly(getCellKey(ssoIdIndex, y), isDisable)
  }
  if (ssoDateIndex > -1) {
    if (isDisable) {
      instance.jexcel.setValueFromCoords(ssoDateIndex, y, null, true);
    }
    instance.jexcel.setReadOnly(getCellKey(ssoDateIndex, y), isDisable)
  }
  return instance
}

export interface EMPLOYEETABLECOLUMNS extends TABLECOLUMNS {
  isEdit?: boolean;
  showString?: boolean;
  settingType: SettingType[];
  showField?: string;
  allowEmpty?: boolean;
  validate?: any;
  synonym?: any;
  prerequisite?: any;
  ignoreZero?: boolean;
  readOnly?: boolean;
  releatedFileds?: string[];
}

export const EmployeeColumns: EMPLOYEETABLECOLUMNS[] = [
  {
    title: 'คำนำหน้า',
    name: 'title',
    type: 'dropdown',
    width: 80,
    source: TitleNames.map(d => d.name),
    required: true,
    settingType: [SettingType.ABOUT],
    synonym: TitleNameSynonyms,
    onChange: onTitleChange
  },
  {
    title: 'ชื่อจริง',
    name: 'first_name',
    type: 'text',
    width: 130,
    required: true,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'นามสกุล',
    name: 'last_name',
    type: 'text',
    width: 130,
    required: true,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'Title',
    name: 'title_en',
    type: 'text',
    width: 80,
    isEdit: true,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'First name',
    name: 'first_name_en',
    type: 'text',
    width: 130,
    isEdit: true,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'Last name',
    name: 'last_name_en',
    type: 'text',
    width: 130,
    isEdit: true,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'การจ้างงาน',
    name: 'employment_type',
    type: 'dropdown',
    width: 130,
    source: Employments.map(d => d.name),
    required: true,
    defaultValue: Employments[1].name,
    settingType: [SettingType.EMPLOYMENT],
    onChange: onEmploymentTypeChange
  },
  {
    title: 'เลขประจำตัวประชาชน',
    name: 'id_card',
    type: 'numberOnly',
    width: 140,
    required: true,
    showString: true,
    settingType: [SettingType.ABOUT, SettingType.EMPLOYMENT],
    maxlength: 13,
    onChange: onIDChange,
    validate: validateID
  },
  {
    title: 'เลขบัตรประกันสังคม',
    name: 'sso_id_card',
    type: 'numberOnly',
    width: 140,
    required: true,
    allowEmpty: true,
    showString: true,
    settingType: [SettingType.EMPLOYMENT],
    maxlength: 13,
    validate: validateSsoIdCard,
    customReadOnly: ssoCustomReadonly
  },
  {
    title: 'ชื่อเล่น',
    name: 'nickname',
    type: 'text',
    width: 80,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'เพศ',
    name: 'sex',
    type: 'dropdown',
    width: 80,
    source: Genders.map(d => d.name),
    required: true,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'วันเกิด',
    name: 'birth_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY', startingDate: new Date().setFullYear(new Date().getFullYear() - 25)},
    width: 110,
    required: true,
    settingType: [SettingType.ABOUT, SettingType.EMPLOYMENT],
    onChange: onBirthDateChange
  },
  {
    title: 'สัญชาติ',
    name: 'nationality',
    type: 'dropdown',
    width: 80,
    source: Nationalities.map(d => d.name),
    required: true,
    defaultValue: Nationalities[0].name,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'สถานภาพ',
    name: 'marital_status',
    type: 'dropdown',
    width: 80,
    source: Status.map(d => d.name),
    required: true,
    defaultValue: Status[0].name,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'พิการ/ทุพพลภาพ',
    name: 'disability_status',
    type: 'dropdown',
    width: 110,
    source: Disabilities.map(d => d.name),
    required: true,
    defaultValue: Disabilities[0].name,
    settingType: [SettingType.ABOUT]
  },
  {
    title: 'เริ่มงาน',
    name: 'start_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY', startingDate: new Date().setDate(1)},
    width: 110,
    required: true,
    settingType: [SettingType.EMPLOYMENT],
    showField: 'dates.0.start_date',
    onChange: onStartDateChange
  },
  {
    title: 'วันที่เข้าประกันสังคม',
    name: 'sso_start_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY', startingDate: new Date().setDate(1)},
    width: 130,
    required: true,
    allowEmpty: true,
    settingType: [SettingType.EMPLOYMENT],
    showField: 'dates.0.sso_start_date',
    onChange: onSsoDateChange,
    customReadOnly: ssoCustomReadonly
    // prerequisite: 'sso_id_card'
  },
  {
    title: 'วันทำงานวันสุดท้าย',
    name: 'end_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY', startingDate: new Date().setDate(1)},
    width: 110,
    allowEmpty: true,
    settingType: [SettingType.EMPLOYMENT],
    showField: 'dates.0.end_date',
    readOnly: true
  },
  {
    title: 'รหัสพนักงาน',
    name: 'employment_id',
    type: 'text',
    width: 90,
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: 'แผนก',
    name: 'department',
    type: 'text',
    width: 130,
    settingType: [SettingType.EMPLOYMENT],
    prerequisite: 'department_start_date'
  },
  {
    title: 'Effective date (แผนก)',
    name: 'department_start_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY', startingDate: new Date().setDate(1)},
    width: 150,
    settingType: [SettingType.EMPLOYMENT],
    isEdit: true,
    prerequisite: 'department'
  },
  {
    title: 'ทีม',
    name: 'team',
    type: 'text',
    width: 130,
    settingType: [SettingType.EMPLOYMENT],
    prerequisite: 'team_start_date'
  },
  {
    title: 'Effective date (ทีม)',
    name: 'team_start_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY', startingDate: new Date().setDate(1)},
    width: 150,
    settingType: [SettingType.EMPLOYMENT],
    isEdit: true,
    prerequisite: 'team'
  },
  {
    title: 'ตำแหน่ง',
    name: 'position',
    type: 'text',
    width: 130,
    settingType: [SettingType.EMPLOYMENT],
    prerequisite: 'position_start_date'
  },
  {
    title: 'Effective date (ตำแหน่ง)',
    name: 'position_start_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY', startingDate: new Date().setDate(1)},
    width: 150,
    settingType: [SettingType.EMPLOYMENT],
    isEdit: true,
    prerequisite: 'position'
  },
  {
    title: 'ค่าจ้าง',
    name: 'salary',
    type: 'numeric',
    width: 100,
    required: true,
    allowEmpty: true,
    mask: '#,##.00',
    decimal: '.',
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: 'จ่ายทุก',
    name: 'salary_period',
    type: 'dropdown',
    width: 80,
    source: Units.map(d => d.name),
    required: true,
    defaultValue: Units[0].name,
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: 'Effective date (ค่าจ้าง)',
    name: 'salary_start_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY', startingDate: new Date().setDate(1)},
    width: 150,
    required: true,
    settingType: [SettingType.EMPLOYMENT],
    isEdit: true
  },
  {
    title: 'เงินประจำตำแหน่ง',
    name: 'position_allowance',
    type: 'numeric',
    width: 130,
    mask: '#,##.00',
    decimal: '.',
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: 'ธนาคาร',
    name: 'bank_id',
    type: 'dropdown',
    width: 80,
    source: Banks.map(d => d.name),
    settingType: [SettingType.EMPLOYMENT],
  },
  {
    title: 'เลขบัญชี',
    name: 'bank_account',
    type: 'numberOnly',
    width: 120,
    settingType: [SettingType.EMPLOYMENT],
    maxlength: 10,
  },
  {
    title: 'ชื่อตามสมุดบัญชี',
    name: 'bank_account_name',
    type: 'text',
    width: 150,
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: '[ลูกจ้าง] กองทุนสำรองเลี้ยงชีพ',
    name: 'provident_fund',
    type: 'numeric',
    width: 160,
    mask: '#,##.00',
    decimal: '.',
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: 'หน่วย',
    name: 'provident_fund_type',
    type: 'dropdown',
    width: 80,
    source: PvdTypes.map(d => d.name),
    defaultValue: PvdTypes[0].name,
    //onChange: onPvdTypeChange,
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: '[นายจ้าง] กองทุนสำรองเลี้ยงชีพ',
    name: 'provident_fund_employer',
    type: 'numeric',
    width: 160,
    mask: '#,##.00',
    decimal: '.',
    settingType: [SettingType.EMPLOYMENT],
  },
  {
    title: 'หน่วย',
    name: 'provident_fund_employer_type',
    type: 'dropdown',
    width: 80,
    source: PvdTypes.map(d => d.name),
    defaultValue: PvdTypes[0].name,
    //onChange: onPvdEmployerTypeChange,
    settingType: [SettingType.EMPLOYMENT],
  },
  {
    title: 'บลจ.',
    name: 'provident_fund_info',
    type: 'dropdown',
    width: 160,
    source: PVDInfo.map(d => d.name),
    settingType: [SettingType.EMPLOYMENT],
    isEdit: true
  },
  {
    title: 'กยศ.',
    name: 'student_loan',
    type: 'numeric',
    width: 100,
    mask: '#,##.00',
    decimal: '.',
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: 'หักกยศ. ถึงวันที่',
    name: 'student_loan_end_date',
    type: 'calendar',
    options: {format: 'DD MMM YYYY'},
    width: 105,
    settingType: [SettingType.EMPLOYMENT]
  },
  {
    title: 'บ้านเลขที่',
    name: 'id_card_address.street_no',
    type: 'text',
    width: 80,
    settingType: [SettingType.CONTACT_IDCARDADDRESS],
  },
  {
    title: 'หมู่ที่',
    name: 'id_card_address.moo_no',
    type: 'text',
    width: 80,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'ชื่ออาคาร',
    name: 'id_card_address.building',
    type: 'text',
    width: 100,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'ห้องเลขที่',
    name: 'id_card_address.room_no',
    type: 'text',
    width: 80,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'ชั้นที่',
    name: 'id_card_address.floor_no',
    type: 'text',
    width: 80,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'หมู่บ้าน',
    name: 'id_card_address.village_name',
    type: 'text',
    width: 100,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'ซอย',
    name: 'id_card_address.soi',
    type: 'text',
    width: 100,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'ตรอก',
    name: 'id_card_address.alley',
    type: 'text',
    width: 100,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'แยก',
    name: 'id_card_address.lane',
    type: 'text',
    width: 80,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'ถนน',
    name: 'id_card_address.road',
    type: 'text',
    width: 100,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'แขวง/ตำบล',
    name: 'id_card_address.sub_district',
    type: 'text',
    width: 80,
    allowEmpty: false,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'เขต/อำเภอ',
    name: 'id_card_address.district',
    type: 'text',
    width: 80,
    allowEmpty: false,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'จังหวัด',
    name: 'id_card_address.province',
    type: 'dropdown',
    width: 130,
    allowEmpty: false,
    source: jExcelProvinces.map(d => d.name),
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'รหัสไปรษณีย์',
    name: 'id_card_address.postal_code',
    type: 'numberOnly',
    maxlength: 5,
    width: 80,
    allowEmpty: false,
    settingType: [SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'บ้านเลขที่',
    name: 'contact_address.street_no',
    type: 'text',
    isEdit: true,
    width: 80,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'หมู่ที่',
    name: 'contact_address.moo_no',
    type: 'text',
    isEdit: true,
    width: 80,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'ชื่ออาคาร',
    name: 'contact_address.building',
    type: 'text',
    isEdit: true,
    width: 100,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'ห้องเลขที่',
    name: 'contact_address.room_no',
    type: 'text',
    isEdit: true,
    width: 80,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'ชั้นที่',
    name: 'contact_address.floor_no',
    type: 'text',
    isEdit: true,
    width: 80,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'หมู่บ้าน',
    name: 'contact_address.village_name',
    type: 'text',
    isEdit: true,
    width: 100,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'ซอย',
    name: 'contact_address.soi',
    type: 'text',
    isEdit: true,
    width: 100,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'ตรอก',
    name: 'contact_address.alley',
    type: 'text',
    isEdit: true,
    width: 100,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'แยก',
    name: 'contact_address.lane',
    type: 'text',
    isEdit: true,
    width: 80,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'ถนน',
    name: 'contact_address.road',
    type: 'text',
    isEdit: true,
    width: 100,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'แขวง/ตำบล',
    name: 'contact_address.sub_district',
    type: 'text',
    isEdit: true,
    width: 80,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'เขต/อำเภอ',
    name: 'contact_address.district',
    type: 'text',
    isEdit: true,
    width: 80,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'จังหวัด',
    name: 'contact_address.province',
    type: 'dropdown',
    isEdit: true,
    width: 130,
    source: jExcelProvinces.map(d => d.name),
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'รหัสไปรษณีย์',
    name: 'contact_address.postal_code',
    type: 'numberOnly',
    maxlength: 5,
    isEdit: true,
    width: 80,
    settingType: [SettingType.CONTACT_CONTACTADDRESS]
  },
  {
    title: 'Email บริษัท',
    name: 'company_email',
    type: 'text',
    width: 130,
    settingType: [SettingType.CONTACT_CONTACTADDRESS, SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'Email ส่วนตัว',
    name: 'personal_email',
    type: 'text',
    width: 130,
    settingType: [SettingType.CONTACT_CONTACTADDRESS, SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'เบอร์โทร',
    name: 'phone1',
    type: 'numberOnly',
    maxlength: 10,
    width: 110,
    settingType: [SettingType.CONTACT_CONTACTADDRESS, SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'เบอร์โทร 2',
    name: 'phone2',
    type: 'numberOnly',
    maxlength: 10,
    width: 110,
    isEdit: true,
    settingType: [SettingType.CONTACT_CONTACTADDRESS, SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'ชื่อ (ติดต่อกรณีฉุกเฉิน)',
    name: 'emergency_contact_person',
    type: 'text',
    width: 150,
    isEdit: true,
    settingType: [SettingType.CONTACT_CONTACTADDRESS, SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'เบอร์ (ติดต่อกรณีฉุกเฉิน)',
    name: 'emergency_contact_no',
    type: 'numberOnly',
    maxlength: 10,
    width: 170,
    isEdit: true,
    settingType: [SettingType.CONTACT_CONTACTADDRESS, SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'ความสัมพันธ์ (ติดต่อกรณีฉุกเฉิน)',
    name: 'emergency_contact_relationship',
    type: 'text',
    width: 220,
    isEdit: true,
    settingType: [SettingType.CONTACT_CONTACTADDRESS, SettingType.CONTACT_IDCARDADDRESS]
  },
  {
    title: 'แพ้อาหาร',
    name: 'emergencyContactRel',
    type: 'other1',
    width: 110,
    isEdit: true,
    settingType: [SettingType.OTHER]
  },
  {
    title: '',
    name: 'ID',
    type: 'hidden',
    isEdit: true,
    settingType: [SettingType.ALL]
  }
];

const today = new Date();
export const MinDatePicker = {year: 1900, month: 1, day: 1};
export const TodayDatePicker = {year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate()};

export const Reasons = [
  {
    value: 'resign',
    label: 'ลาออก',
    itemsTitle: 'เงินก้อนที่จะจ่ายให้เพราะลาออก (ถ้ามี)',
    items: [
      {
        value: 'holidayLeave',
        label: 'ค่าจ้างแทนวันพักร้อนที่ไม่ได้ใช้'
      },
      {
        value: 'compensation',
        label: 'เงินก้อนสุดท้าย'
      }
    ]
  },
  {
    value: 'retire',
    label: 'เกษียณ / หมดสัญญาจ้าง',
    itemsTitle: 'เงินก้อนที่จะจ่ายให้เพราะเกษียณ / หมดสัญญาจ้าง (ถ้ามี)',
    items: [
      {
        value: 'severance',
        label: 'ค่าชดเชย ${xxx} วัน'
      },
      // {
      //   value: 'governmentLastPayment',
      //   label: 'เงินบำเหน็จฯ ข้าราชการ',
      //   customHidden: (endDate: Date) => {
      //     if (endDate < new Date(new Date().setHours(7, 0, 0, 0))) {
      //       return true;
      //     }
      //     return false;
      //   }
      // },
      // {
      //   value: 'earlyRetire',
      //   label: 'เงินเกษียณก่อนกำหนด (Early Retire)',
      //   customHidden: (endDate: Date) => {
      //     if (endDate < new Date(new Date().setHours(7, 0, 0, 0))) {
      //       return true;
      //     }
      //     return false;
      //   }
      // },
      {
        value: 'holidayLeave',
        label: 'ค่าจ้างแทนวันพักร้อนที่ไม่ได้ใช้'
      },
      {
        value: 'compensation',
        label: 'เงินก้อนสุดท้าย'
      },
    ]
  },
  {
    value: 'fired',
    label: 'ไล่ออก',
    itemsTitle: 'เงินก้อนที่จะจ่ายให้เพราะไล่ออก (ถ้ามี)',
    items: [
      {
        value: 'severance',
        label: 'ค่าชดเชย ${xxx} วัน'
      },
      {
        value: 'advanceNotice',
        label: 'สินจ้างแทนการบอกกล่าวล่วงหน้า'
      },
      // {
      //   value: 'governmentLastPayment',
      //   label: 'เงินบำเหน็จฯ ข้าราชการ',
      //   customHidden: (endDate: Date) => {
      //     if (endDate < new Date(new Date().setHours(7, 0, 0, 0))) {
      //       return true;
      //     }
      //     return false;
      //   }
      // },
      {
        value: 'holidayLeave',
        label: 'ค่าจ้างแทนวันพักร้อนที่ไม่ได้ใช้'
      },
      {
        value: 'compensation',
        label: 'เงินก้อนสุดท้าย'
      },
    ]
  }
];

export const columnKeyTh = {
  salary: 'เงินเดือน',
  wage: 'ค่าจ้าง (ลูกจ้างรายวัน)',
  bonus: 'โบนัส',
  commission: 'ค่าคอมมิชชั่น',
  allowance: 'เบี้ยเลี้ยง',
  professionalFee: 'เงินประจำตำแหน่ง',
  holiday: 'ค่าทำงานวันหยุด',
  ot: 'OT ค่าล่วงเวลา',
  otHoliday: 'OT ค่าล่วงเวลาวันหยุด',
  ot_holiday: 'OT ค่าล่วงเวลาวันหยุด',
  phoneBill: 'ค่าโทรศัพท์',
  oilCost: 'ค่าน้ำมัน',
  travelExpense: 'ค่าเดินทาง',
  freeAccommodation: 'ประโยชน์จากการได้ที่พักฟรี',
  taxEmployer: 'ภาษีที่นายจ้างออกให้',
  reservedPayment: 'เงินสำรองจ่าย',
  socialSecurity: 'ประกันสังคม',
  providentFund: 'กองทุนสำรองเลี้ยงชีพ',
  studentLoan: 'กยศ.',
  late: 'มาสาย',
  absent: 'ลา / ขาดงาน / Leave without pay',
  payCut: 'หักเงินเดือน',
  workInsurance: 'เงินประกันการทำงาน',
  withholdingTax: 'ภาษีหัก ณ ที่จ่าย',
  severanceTaxable: 'ค่าชดเชย (เสียภาษี)',
  severanceTaxExempt: 'ค่าชดเชย (ไม่เสียภาษี)',
  advanceNotice: 'สินจ้างแทนการบอกกล่าวล่วงหน้า',
  compensation: 'เงินก้อนสุดท้าย',
  holidayLeave: 'ค่าจ้างแทนวันพักร้อนที่ไม่ได้ใช้',
  withholdingTaxQuit: 'ภาษีหัก ณ ที่จ่าย (ออกจากงาน)'
};


export const quitKeyTh = {
  A1: 'เงินบำเหน็จฯ ข้าราชการ',
  A2: 'เงินที่จ่ายจากกองทุนสำรองเลี้ยงชีพ',
  A3: 'เงินชดเชยตามกฎหมายแรงงาน (หลังจากหักจำนวนเงินที่ได้รับยกเว้นแล้ว)',
  A4: 'รวม',
  A5: 'เงินได้ที่จ่ายให้ครั้งเดียวที่มีวิธีการคำนวณแตกต่างไปจาก 1.',
  A6: 'รวมทั้งสิ้น',
  A7: 'หักได้รับยกเว้น ฿190,000',
  A8: 'คงเหลือ',
  B1: (ref) => {
        let source = 'เฉลี่ย 12 เดือนสุดท้าย + ร้อยละ 10 ของเงินเดือนถัวเฉลี่ย'
        if (ref.B.B1Source === 'lastSalary') {
          source = 'เดือนสุดท้าย'
        }
        return `เงินเดือนรับจากนายจ้าง ${source} (${formatDecimalPrice(+ref.B.B1Base)} × ${ref.misc.YearOfWork})`
      },
  B2: 'จำนวนเงินได้ที่ถือเป็นฐาน เพื่อคำนวณหาค่าใช้จ่าย',
  B3: (ref) => {
        return `ค่าใช้จ่ายส่วนแรก (${formatDecimalPrice(ref.B.B3Base)} × ${ref.misc.YearOfWork})`
      },
  B4: 'คงเหลือ',
  B5: 'ค่าใช้จ่าย ส่วนที่ 2 ร้อยละ 50',
  B6: 'รวมค่าใช้จ่ายที่หักได้ทั้งหมด',
  C1: 'เงินได้พึงประเมิน',
  C2: 'หัก ค่าใช้จ่าย',
  C3: 'เงินได้สุทธิ',
  C4: 'ภาษีคำนวณจากเงินได้สุทธิ'
};
